// frontend/src/supabaseClient.js
import { createClient } from '@supabase/supabase-js';

// Read keys from environment variables
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
    console.error("Supabase URL or Anon Key is missing. Make sure .env file is set up in /frontend folder.");
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Read backend URL from environment variables
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

if (!BACKEND_URL) {
    console.error("Backend URL is missing. Make sure .env file is set up in /frontend folder.");
}